import React from 'react';
import LegalDocument from './LegalDocument';

const TermsConditions = () => {
  return <LegalDocument documentIdBase="terms_conditions" />;
};

export default TermsConditions;
